export enum ObjectEntity {
  DEAL = "deal",
  LEAD = "lead",
  CONTRACT = "contract"
}

export enum ArrayFieldType {
  MULTI_SELECT = "multiSelect",
  ATTACHMENTS = "attachments",
  REMINDERS = "reminders",
  MULTI_EMAIL = "multiEmail"
}
